import * as UsuarioProvider from "../providers/usuario-provider";
import * as GeneralRepository from "../repositories/general-repository";

export const obtenerRoles = async () => {
    const response = await UsuarioProvider.obtenerRoles()
    if(response.auditResponse.codigoRespuesta === '0') {
        return {
            error: null,
            roles: response.listaResponse
        }
    } else {
        if(response.auditResponse.detalle !== undefined && response.auditResponse.detalle.renovarToken) {
            const responseToken = await GeneralRepository.renovarToken()
            if(responseToken !== null && responseToken.error === null) {
                return await obtenerRoles()
            } else {
                return {
                    error: response.auditResponse,
                    roles: null
                }
            }
        } else {
            return {
                error: response.auditResponse,
                roles: null
            }
        }
    }
}

export const obtenerDatosUsuario = async () => {
    const response = await UsuarioProvider.obtenerDatosUsuario()
    if(response.auditResponse.codigoRespuesta === '0') {
        return {
            error: null,
            datosUsuario: response.objectResponse
        }
    } else {
        if(response.auditResponse.detalle !== undefined && response.auditResponse.detalle.renovarToken) {
            const responseToken = await GeneralRepository.renovarToken()
            if(responseToken !== null && responseToken.error === null) {
                return await obtenerDatosUsuario()
            } else {
                return {
                    error: response.auditResponse,
                    datosUsuario: null
                }
            }
        } else {
            return {
                error: response.auditResponse,
                datosUsuario: null
            }
        }
    }
}

export const obtenerIntermediario = async (idIntermediario) => {
    const response = await UsuarioProvider.obtenerIntermediario(idIntermediario)
    if(response.auditResponse.codigoRespuesta === '0') {
        return {
            error: null,
            intermediario: response.entity.data
        }
    } else {
        if(response.auditResponse.detalle !== undefined && response.auditResponse.detalle.renovarToken) {
            const responseToken = await GeneralRepository.renovarToken()
            if(responseToken !== null && responseToken.error === null) {
                return await obtenerIntermediario(idIntermediario)
            } else {
                return {
                    error: response.auditResponse,
                    intermediario: null
                }
            }
        } else {
            return {
                error: response.auditResponse,
                intermediario: null
            }
        }
    }
}